module.exports = __webpack_public_path__ + "static/media/left-arrow.cf431404.svg";